import React from 'react';
import classNames from './../utils/classNames';

const Select = props => {
    const { children, className, value, onChange } = props;
    const childrenCloned = React.Children.map(children, child => React.cloneElement(child, {
        onClick: event => onChange(child.props.value),
        className: classNames(child.props.className, { 'active': child.props.value === value })
    }));
    return (
        <ul className={className}>
            {childrenCloned}
        </ul>
    );
};

export default Select;


// WEBPACK FOOTER //
// ./src/components/Select.js